import { useState } from "react";
import { EMPTY_FORM } from "../../constants/data";
import { IconClose } from "../icons/Icons";

const SELECT_ARROW = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23666'/%3E%3C/svg%3E")`;

const DUMMY_FZG_NUMMER = "dummy_fzg_nummer";

export default function AddVehicleSidebar({ onClose, onSave }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  function set(field, value) {
    setForm(f => ({ ...f, [field]: value }));
    setErrors(e => ({ ...e, [field]: undefined }));
  }

  function handleModeChange(mode) {
    setForm(f => ({
      ...f,
      vehicleExists: mode,
      fahrzeugnummer: mode === "dummy" ? DUMMY_FZG_NUMMER : "",
    }));
    setErrors({});
  }
  function validate() {
    const e = {};
    if (!form.vehicleExists)  e.vehicleExists = "Please select";
    if (form.vehicleExists === "existing" && !form.fahrzeugnummer.trim())
      e.fahrzeugnummer = "Required field";
    if (!form.ba_soll)            e.ba_soll            = "Required field";
    if (!form.aktuelle_station)   e.aktuelle_station   = "Please select";
    return e;
  }

  function handleSave() {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    onSave({      vehicleExists:            form.vehicleExists,
      projektname:              form.projektname,
      projektnummer:            form.projektnummer,
      fahrzeugnummer:           form.fahrzeugnummer,
      fahrzeugverantwortlicher: form.fahrzeugverantwortlicher,
      ba_soll:                  form.ba_soll,
      aktuelle_station:         form.aktuelle_station,
      bau_inkl__ibn:            form.bau_inkl__ibn ? "True" : "False",
      haertegrad:               form.haertegrad,
    });
    onClose();
  }

  const inputStyle = field => ({
    width: "100%", padding: "7px 10px", borderRadius: 6, fontSize: 12,
    color: "#333", background: "white", outline: "none", boxSizing: "border-box",
    border: `1px solid ${errors[field] ? "#dc3545" : "#ccc"}`,
  });

  const selectStyle = field => ({
    ...inputStyle(field),
    cursor: "pointer", appearance: "none",
    backgroundImage: SELECT_ARROW, backgroundRepeat: "no-repeat", backgroundPosition: "right 10px center",
  });

  const labelStyle = { fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" };
  const errStyle   = { fontSize: 10, color: "#dc3545", marginTop: 3 };

  const isDummy    = form.vehicleExists === "dummy";
  const isExisting = form.vehicleExists === "existing";

  return (
    <>      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)", zIndex: 1200 }} />      <div style={{
        position: "fixed", top: 74, right: 0, bottom: 0, width: 320,
        background: "white", boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
        zIndex: 1201,display: "flex", flexDirection: "column", animation: "slideIn 0.22s ease",
      }}>
        <style>{`@keyframes slideIn { from { transform:translateX(100%); } to { transform:translateX(0); } }`}</style>

        {/* Header */}
        <div style={{ background: "#1e6b6b", color: "white", padding: "0 16px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0, height: 50 }}>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "white", display: "flex", alignItems: "center", padding: 2 }}>
            <IconClose />
          </button>
          <span style={{ fontSize: 14, fontWeight: 600 }}>Add Vehicle</span>
          <button onClick={handleSave} style={{ background: "rgba(255,255,255,0.2)", border: "1px solid rgba(255,255,255,0.5)", color: "white", borderRadius: 6, padding: "5px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            Save
          </button>
        </div>

        {/* Form */}
        <div style={{ flex: 1, padding: 18, display: "flex", flexDirection: "column", gap: 16, overflowY: "auto" }}>

          {/* Mode */}
          <div>
            <label style={{ ...labelStyle, marginBottom: 8 }}>Vehicle number already exists?</label>
            <div style={{ display: "flex", gap: 10 }}>
              {[{ value: "dummy", label: "Dummy" }, { value: "existing", label: "Vehicle No. exists" }].map(opt => (
                <label key={opt.value} style={{
                  display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer",
                  flex: 1, padding: "7px 10px", borderRadius: 6, transition: "all 0.15s",
                  border: `1.5px solid ${form.vehicleExists === opt.value ? "#1e6b6b" : "#ccc"}`,
                  background: form.vehicleExists === opt.value ? "#eaf4f4" : "white",
                }}>
                  <input type="radio" name="vehicleExists" value={opt.value}
                    checked={form.vehicleExists === opt.value}
                    onChange={() => handleModeChange(opt.value)}
                    style={{ accentColor: "#1e6b6b" }} />
                  {opt.label}
                </label>
              ))}
            </div>
            {errors.vehicleExists && <div style={errStyle}>{errors.vehicleExists}</div>}
          </div>

          {(isDummy || isExisting) && (<>

            {/* projektname */}
            <div>
              <label style={labelStyle}>Project Name <span style={{ color: "#888", fontWeight: 400 }}>(projektname)</span></label>
              <input style={inputStyle("projektname")} value={form.projektname}
                onChange={e => set("projektname", e.target.value)} placeholder="e.g. MY28 FPP" />
            </div>

            {/* projektnummer */}
            <div>
              <label style={labelStyle}>Project Number <span style={{ color: "#888", fontWeight: 400 }}>(projektnummer)</span></label>
              <input style={inputStyle("projektnummer")} value={form.projektnummer}
                onChange={e => set("projektnummer", e.target.value)} placeholder="e.g. PRJ-001" />
            </div>

            {/* fahrzeugnummer */}
            <div>
              <label style={labelStyle}>
                Vehicle Number <span style={{ color: "#888", fontWeight: 400 }}>(fahrzeugnummer)</span>
                {isExisting && <span style={{ color: "#dc3545" }}> *</span>}
              </label>
              <input
                style={{ ...inputStyle("fahrzeugnummer"), background: isDummy ? "#f0f0f0" : "white", color: isDummy ? "#888" : "#333", cursor: isDummy ? "not-allowed" : "text" }}
                value={form.fahrzeugnummer}
                onChange={e => !isDummy && set("fahrzeugnummer", e.target.value)}
                readOnly={isDummy}
                title={isDummy ? `Auto-set to "${DUMMY_FZG_NUMMER}"` : ""}
                placeholder={isDummy ? DUMMY_FZG_NUMMER : "e.g. 39E-1234"}
              />
              {errors.fahrzeugnummer && <div style={errStyle}>{errors.fahrzeugnummer}</div>}
            </div>

            {/* fahrzeugverantwortlicher */}
            <div>
              <label style={labelStyle}>Vehicle Responsible <span style={{ color: "#888", fontWeight: 400 }}>(fahrzeugverantwortlicher)</span></label>
              <input style={inputStyle("fahrzeugverantwortlicher")} value={form.fahrzeugverantwortlicher}
                onChange={e => set("fahrzeugverantwortlicher", e.target.value)} placeholder="Responsible person" />
            </div>

            {/* ba_soll */}
            <div>
              <label style={labelStyle}>Desired Date <span style={{ color: "#888", fontWeight: 400 }}>(ba_soll)</span> <span style={{ color: "#dc3545" }}>*</span></label>
              <input type="date" style={inputStyle("ba_soll")} value={form.ba_soll}
                onChange={e => set("ba_soll", e.target.value)} />
              {errors.ba_soll && <div style={errStyle}>{errors.ba_soll}</div>}
            </div>            {/* aktuelle_station */}
              <div>
                <label style={labelStyle}>Assembly Line Chassis <span style={{ color: "#888", fontWeight: 400 }}>(aktuelle_station)</span> <span style={{ color: "#dc3545" }}>*</span></label>
                <select style={selectStyle("aktuelle_station")} value={form.aktuelle_station}
                  onChange={e => set("aktuelle_station", e.target.value)}>
                  <option value="">Please select…</option>
                  <option value="chassis">Chassis</option>
                  <option value="cab">Cab Only</option>
                </select>
                {errors.aktuelle_station && <div style={errStyle}>{errors.aktuelle_station}</div>}
              </div>

            {/* haertegrad */}
            <div>
              <label style={labelStyle}>HG Status <span style={{ color: "#888", fontWeight: 400 }}>(haertegrad)</span></label>
              <select style={selectStyle("haertegrad")} value={form.haertegrad}
                onChange={e => set("haertegrad", e.target.value)}>
                {["HG0","HG1","HG2","HG3","HG4","HG5","HG6"].map(h => <option key={h} value={h}>{h}</option>)}
              </select>
            </div>

            {/* bau_inkl__ibn */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", border: "1px solid #dde3e8", borderRadius: 8, background: "#fafafa" }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>Build incl. IBN</div>
                <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>
                  bau_inkl__ibn: <strong>{form.bau_inkl__ibn ? "True" : "False"}</strong>
                </div>
              </div>
              <div onClick={() => set("bau_inkl__ibn", !form.bau_inkl__ibn)}
                style={{ width: 42, height: 24, borderRadius: 12, cursor: "pointer", flexShrink: 0, background: form.bau_inkl__ibn ? "#1e6b6b" : "#ccc", position: "relative", transition: "background 0.2s" }}>
                <div style={{ position: "absolute", top: 3, left: form.bau_inkl__ibn ? 21 : 3, width: 18, height: 18, borderRadius: "50%", background: "white", boxShadow: "0 1px 4px rgba(0,0,0,0.25)", transition: "left 0.2s" }} />
              </div>
            </div>          </>)}
        </div>
      </div>
    </>
  );
}
